import React from "react";
import TopCollectionsItem from '../TopCollectionsItem'
import InfoComponent from '../InfoComponent'
import {TopCollectionsData} from '../../data/data-components/data-TopCollections.js'
// import TopCollectionsData from './data.json'

function TopCollectionsContainer(){

  return(
    <section className="section-padding-100 clearfix" >
        <div className="container">
            <InfoComponent
              titleSm="Check out our Scrap Guild's Lore Collection"
              titleLg='- Collection Items -'
              text='The Collection features limited NFTs of Ships and Lore Items'
            />
            <div className="row">
              {TopCollectionsData && TopCollectionsData.map((item , i) => (
                <TopCollectionsItem
                  img={item.img}
                  title={item.title}
                  text={item.text}
                  Delay={item.Delay}
                />
              ))}
            </div>
        </div>
    </section>
  )
}

export default TopCollectionsContainer